<template>
  <AuthContainer>
    <template #form>
      <NhstVerifyUsername />
    </template>
  </AuthContainer>
</template>

<script>
import {
  AuthContainer
} from '../components';
import Page from '@pages/Page.js';
import { NhstVerifyUsername } from '@components';

export default {
  name: 'verify-username-page',
  components: {
    NhstVerifyUsername,
    AuthContainer,
  },
  extends: Page,
  methods: {
    getTitle() {
      return `${this.$t('registration.page.title')} | ${this.publication.title}`;
    }
  }
};

</script>
